import { IonIcon } from '@ionic/react';
import { sadOutline } from 'ionicons/icons';
import React from 'react';

export default function DeliveryClosedNotice({ reason, onDismiss }: { reason: string; onDismiss: () => void }) {
  return (
    <div className="modal-promocional-container">
      <div className="modal-image-section">
        <header className="modal-impact-header">
          <IonIcon icon={sadOutline} aria-hidden="true" style={{ fontSize: '44px', marginBottom: '10px' }} />
          <h2 className="modal-impact-title">Temporariamente fechada</h2>
          <p className="modal-impact-subtitle">Não estamos recebendo novos pedidos no momento</p>
        </header>
        <div className="modal-promo-content">
          {reason && (
            <div className="promo-item-impact">
              <div className="promo-item-info" style={{ minWidth: 0, overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
                <h4>Motivo do fechamento</h4>
                <p>{reason}</p>
              </div>
            </div>
          )}
          <p style={{ margin: 0, fontSize: '14px', color: 'var(--pedido-text-secondary)', textAlign: 'center' }}>
            Você pode continuar consultando o cardápio enquanto os pedidos estão pausados.
          </p>
        </div>
        <footer className="modal-footer-impact">
          <button className="modal-impact-cta" onClick={onDismiss}>Continuar</button>
        </footer>
      </div>
    </div>
  );
}
